module.exports = __webpack_public_path__ + "img/shuilian3.65000874.gif";